// Auto-generated by scripts/generate-hook-exports.cjs - DO NOT EDIT
import { getter } from "@/lib/contract-interactions/hooks";

export const {
  useAccEthPerShare,
  useAcceptOwnership,
  useCooldownDuration,
  useGetActiveOracleIds,
  useGetBalance,
  useGetBalanceSSV,
  useGetBurnRate,
  useGetBurnRateSSV,
  useGetClusterAssetType,
  useGetCommittedRoot,
  useGetEffectiveBalance,
  useGetLiquidationThresholdPeriod,
  useGetLiquidationThresholdPeriodSSV,
  useGetMaximumOperatorFee,
  useGetMaximumOperatorFeeSSV,
  useGetMinimumLiquidationCollateral,
  useGetMinimumLiquidationCollateralSSV,
  useGetMinimumOperatorEthFee,
  useGetNetworkEarnings,
  useGetNetworkEarningsSSV,
  useGetNetworkFee,
  useGetNetworkFeeSSV,
  useGetNetworkValidatorsCount,
  useGetOperatorById,
  useGetOperatorByIdSSV,
  useGetOperatorDeclaredFee,
  useGetOperatorEarnings,
  useGetOperatorEarningsSSV,
  useGetOperatorFee,
  useGetOperatorFeeIncreaseLimit,
  useGetOperatorFeePeriods,
  useGetOperatorFeeSSV,
  useGetOracle,
  useGetOracleWeight,
  useGetQuorumBps,
  useGetValidator,
  useGetValidatorsPerOperatorLimit,
  useGetVersion,
  useGetWhitelistedOperators,
  useInitialize,
  useIsAddressWhitelistedInWhitelistingContract,
  useIsLiquidatable,
  useIsLiquidatableSSV,
  useIsLiquidated,
  useIsWhitelistingContract,
  useOwner,
  usePendingOwner,
  usePendingUnstake,
  usePreviewClaimableEth,
  useProxiableUUID,
  useRenounceOwnership,
  useSsvNetwork,
  useStakedBalanceOf,
  useStakingEthPoolBalance,
  useTotalStaked,
  useTransferOwnership,
  useUpgradeTo,
  useUpgradeToAndCall,
} = getter;
